<div class="nav-main content-web-section" >
    <img src="assets/images/close.png" class="close-button cursor-pointer" (click)="closePop()">
    <ul class="menus">
        <li class="cursor-pointer">
          <a (click)="accountStatements()">Account Statements</a>
        </li>
      <ng-container *ngFor="let item of menuItems">
        <li  *ngIf="!item?.disabled" class="cursor-pointer" >
          <a [routerLink]="[item.url]" (click)="navPage()">{{item.displayName}}</a>
      </li>
    </ng-container>
            <br><br><br><br><br>
    </ul>

</div>

<div class="nav-main nav-main-mobile content-mobile-section" >
  <img src="assets/images/close.png" class="close-button cursor-pointer" (click)="closePop()">
  <ul class="menus">
    <ng-container *ngFor="let item of menuItems">
      <li *ngIf="!item?.disabled" class="cursor-pointer">
        <a [routerLink]="[item.url]" (click)="navPage()">{{item.displayName}}</a>
    </li>
  </ng-container>
          <br><br><br><br><br>
  </ul>

</div>
